<div class="p-3 mb-4 bg-light rounded-3">
    <div class="col-12 mb-3">
        <div class="titletoptables">
            <div class="leftsideicons">
                <img src="../../assets/image/general-setting-icon.png" alt="generalsettingicon" />
            </div>
            <h3>{{ "Maintenance" }}</h3>
        </div>
    </div>
    <div class="profile">
        <form [formGroup]="maintenanceForm" (ngSubmit)="submit(maintenanceForm)" autocomplete="off">
            <div class="row">
                <!-- Message Field -->
                <div class="col-12">
                    <mat-form-field class="w-100 custom-blue">
                        <mat-label>Message</mat-label>
                        <textarea matInput formControlName="message" placeholder="Enter maintenance message" rows="5"
                            required></textarea>
                        <mat-error
                            *ngIf="maintenanceForm.controls['message'].hasError('required') || maintenanceForm.get('message').errors?.whitespace">
                            Message is required
                        </mat-error>
                        <mat-error
                            *ngIf="maintenanceForm.controls.message.value && maintenanceForm.controls.message.value.trim().length === 0">
                            Message cannot be empty or contain only white space.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="row mt-2">
                    <!-- Start Date & Time -->
                    <div class="col-12 col-md-6">
                        <mat-form-field class="w-100 custom-blue">
                            <mat-label>Start Date</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="StartDate" [min]="today" style="margin-top: 5px;"/>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error
                                *ngIf="maintenanceForm.get('StartDate')?.touched && maintenanceForm.get('StartDate')?.invalid">
                                <ng-container *ngIf="maintenanceForm.get('StartDate')?.errors?.['required']">
                                    Start date is required
                                </ng-container>
                                <ng-container *ngIf="maintenanceForm.get('StartDate')?.errors?.['pastDate']">
                                    Start date must be today or later
                                </ng-container>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="d-flex flex-column">
                            <label for="startTime" class="floating-label">Start Time</label>
                            <kendo-timepicker [format]="'HH:mm'" formControlName="startTime" required
                                class="w-100"></kendo-timepicker>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <!-- End Date & Time -->
                    <div class="col-12 col-md-6">
                        <mat-form-field class="w-100 custom-blue">
                            <mat-label>End Date</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="EndDate" [min]="today" style="margin-top: 5px;"/>
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="maintenanceForm.get('EndDate')?.touched && maintenanceForm.get('EndDate')?.invalid">
                                <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['required']">
                                    End date is required
                                </ng-container>
                                <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['endBeforeStart']">
                                    End date cannot be earlier than start date
                                </ng-container>
                                <ng-container *ngIf="maintenanceForm.get('EndDate')?.errors?.['pastDate']">
                                    End date must be today or later
                                </ng-container>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="d-flex flex-column">
                            <label for="endTime" class="floating-label">End Time</label>
                            <kendo-timepicker [format]="'HH:mm'" formControlName="endTime" required
                                class="w-100"></kendo-timepicker>
                        </div>
                    </div>
                </div>

                <!-- Maintenance Toggle -->
                <div class="col-12 mt-4">
                    <div class="d-flex align-items-center gap-2">
                        <mat-label>Maintenance Mode</mat-label>
                        <mat-slide-toggle color="primary" formControlName="isMaintenance"
                            (change)="openDialogRefforactive($event)"></mat-slide-toggle>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="col-12 mt-4">
                    <button type="submit" id="kt_login_signin_submit" class="btn btn-primary px-4">
                        Submit
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>